import { securityAuthenticationLoginPostAsyncSlice } from './post';

export const {
	requestPostSecurityAuthorizationLogin,
	resetPostSecurityAuthorizationLogin
} = securityAuthenticationLoginPostAsyncSlice.asyncActionCreators;
